module.exports = __webpack_public_path__ + "img/sicantik.461db576.png";